import React from "react";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./CheckListItem.module.css";
import { Close as Cross, IkonateContext } from "react-ikonate";
import classNames from "classnames";

/**
 * Interactive component. A checkmark input that adds a rule to a list filter.
 */
export function CheckListItem({ itemTitle, isChecked, onClick }) {
  /** 
   * Dynamically render appropriate UI appearance based on theme changes (re-renders upon theme change as well)
   */
  const [isDarkMode, setIsDarkMode] = useState(
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const listener = (e) => setIsDarkMode(e.matches);

    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, []);
  const activeColor = isDarkMode ? "#fff" : "#333"; // White font in dark themes, dark gray in light themes
  const inactiveColor = "#888";

  return (
    <div className={styles.container}>
      <div className={styles.checkboxWrapper}>
      <input
        type="checkbox"
        checked={isChecked}
        className={styles.hiddenCheckbox}
        onChange={onClick}
      />
      <span
        className={classNames(styles.customCheckbox, {
          [styles.crossed]: isChecked,
        })}
      />
      </div>
      {/* Update to handle bolded text for conditional filtering */}
      <div className={styles.itemTitle}>{itemTitle}</div>
    </div>
  );
}

CheckListItem.propTypes = {
  /**
   * Title of the condition.
   */
  itemTitle: PropTypes.string,
  /**
   * Determines whether the checkbox is checked or not.
   */
  isChecked: PropTypes.bool,
  /**
   *  A function that fires when the checkbox is clicked.
   */
  onClick: PropTypes.func,
};
